<template>
  <el-dialog
    title="通话详情"
    :visible="visible"
    @close="handleClose"
    width="500px"
    center>
    <div class="call-detail" v-if="detail">
      <el-descriptions :column="1" border>
        <el-descriptions-item label="主叫号码">
          {{ detail.caller }}
        </el-descriptions-item>
        <el-descriptions-item label="被叫号码">
          {{ detail.called }}
        </el-descriptions-item>
        <el-descriptions-item label="被叫归属地">
          {{ detail.calledCityCode || '--' }}
        </el-descriptions-item>
        <el-descriptions-item label="开始时间">
          {{ formatDateTime(detail.beginTime) }}
        </el-descriptions-item>
        <el-descriptions-item label="结束时间">
          {{ formatDateTime(detail.endTime) }}
        </el-descriptions-item>
        <el-descriptions-item label="通话时长">
          {{ formatDuration(detail.chargeCallTime) }}
        </el-descriptions-item>
        <el-descriptions-item label="通话状态">
          {{ getCallStatus(detail.callStatus) }}
        </el-descriptions-item>
        <el-descriptions-item label="呼叫类型">
          {{ detail.callType === 1 ? '呼入' : '呼出' }}
        </el-descriptions-item>
        <el-descriptions-item label="通话录音">
          <div class="audio-player" v-if="audioUrl">
            <audio
              ref="audioPlayer"
              :src="audioUrl"
              @play="onPlay"
              @pause="onPause"
              @ended="onEnded"
              class="hidden-audio">
              您的浏览器不支持音频播放
            </audio>
            <div class="custom-audio-controls">
              <el-button 
                type="primary"
                size="small"
                :icon="isPlaying ? 'el-icon-video-pause' : 'el-icon-video-play'"
                @click="togglePlay">
                {{ isPlaying ? '暂停' : '播放' }}
              </el-button>
              <div class="time-display">
                <span class="time-text">{{ currentTime }}</span>
                <span class="time-separator">/</span>
                <span class="time-text">{{ duration }}</span>
              </div>
            </div>
          </div>
          <div v-else-if="loading" class="loading-text">
            录音加载中...
          </div>
          <div v-else class="no-audio">
            暂无录音
          </div>
        </el-descriptions-item>
      </el-descriptions>
    </div>
  </el-dialog>
</template>

<script>
import { formatDateTime, formatDuration } from '@/utils/format'

export default {
  name: 'CallDetail',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    detail: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      audioUrl: '',
      isPlaying: false,
      loading: false,
      currentTime: '00:00',
      duration: '00:00'
    }
  },
  watch: {
    visible(val) {
      console.log('visible', val)
      if (!val) {
        this.$emit('update:visible', false)
        this.stopAudio()
      } else if (this.detail) {
        this.fetchAudioUrl()
      }
    }
  },
  methods: {
    formatDateTime,
    formatDuration,

    // 获取音频URL
    async fetchAudioUrl() {
      this.loading = true
      this.audioUrl = ''
      console.log('this.detail', this.detail)
      try {
        const response = await this.$http.post('/queryAudio', {
          callId: this.detail.callId,
          // searchDate: this.detail.searchDate.replace(/-/g, ''),
        })
        if (response.data.result && response.data.data.downLoadUrl) {
          this.audioUrl = response.data.data.downLoadUrl
        }
      } catch (error) {
        console.error('获取录音失败:', error)
        // this.$message.error('获取录音失败')
      } finally {
        this.loading = false
      }
    },

    // 播放/暂停切换
    togglePlay() {
      const audio = this.$refs.audioPlayer
      if (audio) {
        if (this.isPlaying) {
          audio.pause()
        } else {
          audio.play()
        }
      }
    },

    // 停止播放
    stopAudio() {
      const audio = this.$refs.audioPlayer
      if (audio) {
        audio.pause()
        audio.currentTime = 0
        this.isPlaying = false
        this.currentTime = '00:00'
      }
    },

    // 播放事件处理
    onPlay() {
      this.isPlaying = true
      this.updateTime()
    },

    // 暂停事件处理
    onPause() {
      this.isPlaying = false
    },

    // 播放结束事件处理
    onEnded() {
      this.isPlaying = false
      this.currentTime = this.duration
    },

    // 更新时间显示
    updateTime() {
      const audio = this.$refs.audioPlayer
      if (audio) {
        // 更新总时长
        const totalMinutes = Math.floor(audio.duration / 60)
        const totalSeconds = Math.floor(audio.duration % 60)
        this.duration = `${String(totalMinutes).padStart(2, '0')}:${String(totalSeconds).padStart(2, '0')}`

        // 定时更新当前时间
        const updateCurrentTime = () => {
          if (this.isPlaying) {
            const minutes = Math.floor(audio.currentTime / 60)
            const seconds = Math.floor(audio.currentTime % 60)
            this.currentTime = `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`
            requestAnimationFrame(updateCurrentTime)
          }
        }
        updateCurrentTime()
      }
    },

    getCallStatus(callStatus) {
      switch (callStatus) {
        case 1:
          return '处理中'
        case 2:
          return '已接听'
        case 3:
          return '振铃中'
        case 4:
          return '通话中'
        case 5:
          return '呼叫失败'
        case 0:
          return '通话结束'
        default:
          return '未知状态'
      }
    },

    // 添加关闭处理方法
    handleClose() {
      this.$emit('update:visible', false)
      this.stopAudio()
    }
  }
}
</script>

<style scoped>
.call-detail {
  padding: 10px;
}

.el-descriptions {
  margin: 10px 0;
}

.el-descriptions-item__label {
  width: 120px;
  background-color: #f5f7fa !important;
}

.el-descriptions-item__content {
  padding: 12px 15px !important;
}

.audio-player {
  width: 100%;
  padding: 10px 0;
}

.audio-player audio {
  width: 100%;
  outline: none;
}

.audio-controls {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-top: 5px;
}

.audio-time {
  color: #606266;
  font-size: 13px;
}

.loading-text {
  color: #909399;
  font-size: 14px;
  text-align: center;
  padding: 10px 0;
}

.no-audio {
  color: #909399;
  font-size: 14px;
  text-align: center;
  padding: 10px 0;
}

/* 隐藏原生音频控件 */
audio::-webkit-media-controls-panel {
  background-color: #f5f7fa;
}

audio::-webkit-media-controls-play-button,
audio::-webkit-media-controls-timeline,
audio::-webkit-media-controls-current-time-display,
audio::-webkit-media-controls-time-remaining-display,
audio::-webkit-media-controls-time-remaining-display,
audio::-webkit-media-controls-mute-button,
audio::-webkit-media-controls-volume-slider {
  display: none;
}

/* 隐藏原生audio标签 */
.hidden-audio {
  display: none;
}

/* 自定义播放控件样式 */
.custom-audio-controls {
  display: flex;
  align-items: center;
  gap: 15px;
  padding: 10px;
  background: #f5f7fa;
  border-radius: 4px;
}

.time-display {
  color: #606266;
  font-size: 14px;
  display: flex;
  align-items: center;
  gap: 5px;
}

.time-text {
  font-family: monospace;
}

.time-separator {
  color: #909399;
}

/* 删除之前的音频控件相关样式 */
audio::-webkit-media-controls-panel,
audio::-webkit-media-controls-play-button,
audio::-webkit-media-controls-timeline,
audio::-webkit-media-controls-current-time-display,
audio::-webkit-media-controls-time-remaining-display,
audio::-webkit-media-controls-time-remaining-display,
audio::-webkit-media-controls-mute-button,
audio::-webkit-media-controls-volume-slider {
  display: none;
}
</style> 